module.exports = __webpack_public_path__ + "img/bbbb.5f691500.jpg";